import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Instagram, Facebook, Send } from 'lucide-react';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-60">
      <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" data-id="element-61" />
    </svg>;
}
export function Contact() {
  return <section id="contact" className="py-32 bg-ivory text-midnight" data-id="element-62">
      <div className="max-w-7xl mx-auto px-6" data-id="element-63">
        <div className="text-center mb-16" data-id="element-64">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight/5 rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-65">
            Get in Touch
          </div>
          <h3 className="text-5xl md:text-7xl font-display font-bold tracking-tighter" data-id="element-66">
            Connect{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-67">
              With Us
            </span>
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-68">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-10 rounded-[2rem] border-2 border-midnight/5 text-center flex flex-col items-center hover:-translate-y-2 transition-transform duration-300 shadow-sm hover:shadow-xl" data-id="element-69">
            <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mb-8 text-midnight shadow-lg" data-id="element-70">
              <MapPin className="w-8 h-8" data-id="element-71" />
            </div>
            <h4 className="text-2xl font-display font-bold mb-4" data-id="element-72">Location</h4>
            <p className="text-lg font-medium text-charcoal/70" data-id="element-73">
              Ugbowo, Benin City
              <br data-id="element-74" />
              Edo State, Nigeria
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-10 rounded-[2rem] border-2 border-midnight/5 text-center flex flex-col items-center hover:-translate-y-2 transition-transform duration-300 shadow-sm hover:shadow-xl" data-id="element-75">
            <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mb-8 text-midnight shadow-lg" data-id="element-76">
              <Phone className="w-8 h-8" data-id="element-77" />
            </div>
            <h4 className="text-2xl font-display font-bold mb-4" data-id="element-78">Phone</h4>
            <p className="text-lg font-medium text-charcoal/70" data-id="element-79">
              +234 806 117 7617
              <br data-id="element-80" />
              +234 812 555 2897
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-10 rounded-[2rem] border-2 border-midnight/5 text-center flex flex-col items-center hover:-translate-y-2 transition-transform duration-300 shadow-sm hover:shadow-xl" data-id="element-81">
            <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mb-8 text-midnight shadow-lg" data-id="element-82">
              <Mail className="w-8 h-8" data-id="element-83" />
            </div>
            <h4 className="text-2xl font-display font-bold mb-4" data-id="element-84">
              Email & Social
            </h4>
            <a href="mailto:campdavidprayerplatform@outlook.com" className="text-sm font-medium text-charcoal/70 hover:text-gold transition-colors block mb-6" data-id="element-85">
              campdavidprayerplatform@outlook.com
            </a>
            <div className="flex items-center flex-wrap justify-center gap-3" data-id="element-86">
              <a href="mailto:campdavidprayerplatform@outlook.com" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="Email" data-id="element-87">
                <Mail className="w-5 h-5" data-id="element-88" />
              </a>
              <a href="https://www.instagram.com/campdavidprayerplatform?igsh=czk3cm92d3k2bnB2&utm_source=ig_contact_invite" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="Instagram" data-id="element-89">
                <Instagram className="w-5 h-5" data-id="element-90" />
              </a>
              <a href="https://www.facebook.com/share/18Uxv6Kc87/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="Facebook" data-id="element-91">
                <Facebook className="w-5 h-5" data-id="element-92" />
              </a>
              <a href="https://www.tiktok.com/@campdavidnation?_r=1&_t=ZS-96iUSUYiIqr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="TikTok" data-id="element-93">
                <TikTokIcon className="w-5 h-5" data-id="element-94" />
              </a>
              <a href="https://t.me/+clyrH4FDK9JlNmU8" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="Telegram" data-id="element-95">
                <Send className="w-5 h-5" data-id="element-96" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}